import { useContext, useEffect, useState } from 'react';
import { InterruptionReferenceModelAPI } from '../../../../models';
import { BaseSelector } from '../../../../models/baseSelector';
import { AppContext } from '../../../context';
import Select, { SingleValue } from 'react-select';

interface Props {
    name: string;
    disable?: boolean;
    onChange: (name: string, value: string | null | number | undefined) => void;
    value: string | undefined | number;
    label?: string;
}

export const InterruptionReferenceSelector = ({
    name,
    onChange,
    disable = false,
    value,
    label,
}: Props) => {
    const { langResources, interruptionReferenceTypesList } = useContext(AppContext);

    const [dataList, setDataList] = useState<BaseSelector[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        const convertedResponse = interruptionReferenceTypesList.map(
            (item: InterruptionReferenceModelAPI) => {
                return {
                    label: item.name,
                    value: item.id,
                };
            }
        );
        setIsLoadingData(false);
        setDataList(convertedResponse);
    }, []);

    return (
        <>
            {label && label.trim() !== '' && <label>{label}:</label>}

            <div className='p-0 m-0'>
                <Select
                    id={name}
                    key={name}
                    name={name}
                    options={dataList}
                    isLoading={isLoadingData}
                    className='text-dark p-0 m-0'
                    isSearchable={true}
                    placeholder={
                        label ? label : 'Seleccionar referencias de interrupciones'
                    }
                    onChange={(e) => {
                        onChange(name, e?.value);
                    }}
                    value={
                        dataList.find((a) => a.value === value) ?? {
                            label: 'Seleccionar referencias de interrupciones',
                            value: 0,
                        }
                    }
                />
            </div>
        </>
    );
};
